export function buildFormData(values, token) {
    const formData = new FormData();

    const { tuitionFiles, reasonFiles, ...otherValues } = values;

    formData.append('file', new Blob([JSON.stringify(values)], { type: 'application/json' }));

    const appendFile = (file) => {
        formData.append('attachments', file);
    };

    if (tuitionFiles) {
        tuitionFiles.forEach(file => {
            const newName = 'tuition_' + file.name; 
            const fileWithNewName = new File([file], newName, { type: file.type });
            appendFile(fileWithNewName);
        })

    }

    if (reasonFiles) {
        reasonFiles.forEach(file => {
            const newName = 'reason_' + file.name; 
            const fileWithNewName = new File([file], newName, { type: file.type });
            appendFile(fileWithNewName);
        });
    }

    formData.append('formValues', JSON.stringify(otherValues));

    formData.append('token', token);
    formData.append('status', 'Pending');
    formData.append('applicantFirstName', values.fillerFirstName || '');
    formData.append('applicantLastName', values.fillerLastName || '');
    formData.append('beneficiaryFirstName', values.beneficiaryFirstName || '');
    formData.append('beneficiaryLastName', values.beneficiaryLastName || '');

    return formData;
}